import { appInsights } from '.';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IPageViewTracker } from './IPageViewTracker';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store/ducks';

export const PageViewTracker: React.FC<IPageViewTracker> = (props) => {
  const location = useLocation();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.user);

  useEffect(() => {
    const pageName = pathname.split('-').join(' ').slice(1);
    dispatch({ type: 'SET_TRACKING', data: { pageTitle: pageName } });
  }, [pathname]);

  useEffect(() => {
    if (props.trackOnlyAuthenticated && user?.id) {
      appInsights.trackPageView({
        isLoggedIn: true,
        name: document.title,
        uri: window.location.href,
        properties: {
          perfil: user.userType,
        },
      });
    }
  }, [location, user]);

  return <></>;
};
